"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.currencySymbol = void 0;
exports.currencySymbol = "N$";
